export class ProjectMemberCreationModel {
    constructor() {
        this.employeeId = "";
        this.projectId = "";
    }
}
export default class ProjectMemberCreation extends ProjectMemberCreationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
